// extracted by mini-css-extract-plugin
export default {"editIdentifierDialog":"styles_editIdentifierDialog__3WnaR","editIdentifierBtnRow":"styles_editIdentifierBtnRow__P0v8E","editIdentifierBtn":"styles_editIdentifierBtn__FaPmi"};